// eslint-disable-next-line import/no-mutable-exports
import { TimeRange } from '@kentik/ui-shared/query/query.types';

// TODO I think this is a bad idea but it's out of scope for me to fix
// eslint-disable-next-line import/no-mutable-exports
export let BOARD_LABEL = 'Observation Deck';

export interface Variable {
  enabled?: boolean;
  type?: 'guided' | 'custom';
  guidedType?: string;
  field?: string;
  name: string;
  value: string | string[] | null;
  options?: { value: string; label?: string }[];
  allowMulti?: boolean;
  exactMatch?: boolean;
  operator?: string;
}

export function normalizeVariableName(name: string): string {
  return name.trim().toLowerCase();
}

export function generateUniqueVariableName(baseName: string, existingNames: string[]): string {
  const taken = new Set(existingNames.map(normalizeVariableName));
  let candidate = baseName;
  let suffix = 2;
  while (taken.has(normalizeVariableName(candidate))) {
    candidate = `${baseName} ${suffix}`;
    suffix += 1;
  }
  return candidate;
}

export function setBoardLabel(label: string) {
  BOARD_LABEL = label;
}

export interface MnBoardCommonFields {
  id: number;
  company_id: string;
  user_id?: string;
  title?: string;
  cdate: Date;
  edate: Date;
  config: {
    description?: string;
  };
}

export interface MnBoard extends MnBoardCommonFields {
  share_level: 'self' | 'org';
  draft: boolean;
  title: string;
  type: string | null;
  config: MnBoardCommonFields['config'] & {
    layoutMode?: string;
    // explicitly convert to dashboard, even if there's only one panel
    isDashboard?: boolean;
    time?: TimeRange;
    timezone?: string;
    variables?: Variable[];
    updateFrequency?: number;
    presetFilters?: unknown[];
  };
}

export type BoardData = MnBoard;
